/* global femcare */

/**
 * Audio Platform Embed Manager
 * Unified handler for embedding audio content from various platforms (SoundCloud, Spotify)
 * with accessibility improvements.
 */
femcare.audioPlatform = {
    /**
     * Platform-specific configuration and processing methods
     * @type {Object.<string, PlatformConfig>}
     */
    platforms: {
        soundcloud: {
            selector: '.podcast__embed--soundcloud',
            dataAttr: 'data-soundcloud-source',

            /**
             * Process SoundCloud embed using oEmbed API
             * @param {jQuery} $container - Container element for the embed
             * @param {string} source - SoundCloud URL
             * @param {string} [title] - Accessibility title for iframe
             */
            processEmbed($container, source, title) {
                const maxHeight = 166;
                const url = `https://soundcloud.com/oembed?url=${encodeURIComponent(source)}&maxheight=${maxHeight}`;

                $.get(url).done((data) => {
                    let html = data.html.replace('visual=true', 'visual=false');

                    if (title) {
                        html = html.replace('<iframe', `<iframe title="${title}"`);
                    }

                    $container.html(html);
                });
            }
        },
        spotify: {
            selector: '.podcast__embed--spotify',
            dataAttr: 'data-spotify-source',

            /**
             * Process Spotify embed by constructing iframe directly
             * @param {jQuery} $container - Container element for the embed
             * @param {string} source - Spotify URL (show or episode)
             * @param {string} [title] - Accessibility title for iframe
             */
            processEmbed($container, source, title) {
                const embedPodcastRoute = 'https://open.spotify.com/embed-podcast/';
                let url = null;

                if (source.indexOf(embedPodcastRoute) === 0) {
                    url = source;
                } else {
                    // Expected podcast source values:
                    // https://open.spotify.com/show/0DodjCkSO2sTNG1CCgBPn6
                    // https://open.spotify.com/episode/3irbZfXyHrs85F9hpccmOI
                    const trackIdentifier = (/https:\/\/open\.spotify\.com\/(.*)/).exec(source)[1];
                    url = embedPodcastRoute + trackIdentifier;
                }

                const titleAttr = title ? ` title="${title}"` : '';
                const $iframe = $(`<iframe src="${url}"${titleAttr} width="100%" height="166" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`);
                $container.html($iframe);
            }
        }
    },

    /**
     * Initialize audio platform embeds for all supported platforms
     * Searches for platform-specific containers and processes their embed data
     */
    init() {
        Object.keys(this.platforms).forEach((platformName) => {
            const platform = this.platforms[platformName];
            const $podcasts = $(platform.selector);

            if ($podcasts.length) {
                $podcasts.each((index, element) => {
                    const $container = $(element);
                    const source = $container.attr(platform.dataAttr);
                    const title = $container.attr('data-iframe-title');
                    platform.processEmbed($container, source, title);
                });
            }
        });
    }
};